import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useAppStateStore = defineStore('appState', () => {
  // Properties that are set dynamically by the hydration process
  const siteUrl = ref('');
  const logoutUrl = ref('');
  const userBarMessage = ref('');
  const livestreamHudEnabled = ref(false);
  const academicYearStartMonth = ref(null);
  const pageThemes = ref({});

  return {
    siteUrl,
    logoutUrl,
    userBarMessage,
    livestreamHudEnabled,
    academicYearStartMonth,
    pageThemes,
  };
});
